import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'passwordIcon', 'textIcon'];

  toggleSecret() {
    const input = this.inputTarget;
    const passwordIcon = this.passwordIconTarget;
    const textIcon = this.textIconTarget;

    if (input.type === 'password') {
      input.type = 'text';
      input.disabled = false;
      input.classList.remove('bg-misty-mountains');
      input.placeholder = 'Enter secret';

      textIcon.classList.remove('hidden');
      passwordIcon.classList.add('hidden');
    } else {
      input.type = 'password';
      input.disabled = true;
      input.classList.add('bg-misty-mountains');
      input.placeholder = '***********';

      textIcon.classList.add('hidden');
      passwordIcon.classList.remove('hidden');
    }
  }
}
